import React from 'react';
import { Routes as ReactRouterRoutes, Route, useLocation } from 'react-router-dom';
import { ReviewList } from './Review/List';
import { useProject } from './Providers/ProjectProvider';
import { Loading } from '@shopify/polaris';
import ProjectGenerator from './ProjectGenerator';
import { FullReview } from './Review/Full';
import { useUser } from './Providers/UserProvider';
import ManageSubscription from './ManageSubscription';
import SubscriptionVerification from './SubscriptionVerification';

function useQuery () {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Routes () {
  const query = useQuery();
  const { loading: userLoading, user } = useUser();
  const { loading: projectLoading, project } = useProject();

  function requireApiKey (component: React.ReactElement) {
    if (userLoading) {
      return <Loading />;
    }
    return component;
  }
  function requireProject (component: React.ReactElement) {
    if (query.get('charge_id')) {
      return <SubscriptionVerification />;
    }
    if (userLoading || !user?.apiKey) {
      return requireApiKey(component);
    }
    if (!user?.activeShopifySubscription) {
      return requireSubscription(component);
    }
    if (projectLoading) {
      return <Loading />;
    }
    if (!project) {
      return (
        <ProjectGenerator
          apiKey={user.apiKey}
          url={new URL(location.toString()).searchParams.get('shop') || ''}
        />
      );
    }
    return component;
  }
  function requireSubscription (component: React.ReactElement) {
    if (userLoading) {
      return requireApiKey(component);
    }
    if (!user?.activeShopifySubscription) {
      return (
        <ManageSubscription user={user!} />
      );
    }
    return component;
  }

  const routes = (
    <ReactRouterRoutes>
      <Route
        path='/shopify'
        element={requireProject(
          <ReviewList
            apiKey={user?.apiKey || ''}
            project={project}
            host={new URL(location.toString()).searchParams.get('shop') || ''}
          />
        )}
      />
      <Route path='/shopify/review-display/:url' element={<FullReview />} />
    </ReactRouterRoutes>
  );

  return <>{routes}</>;
}
export { Routes };
